<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="currencyAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="data" class="form-label">Data:</label>
                    <textarea id="data" class="form-control" name="data" v-model="formData.data" :class="classes"></textarea>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="currency_id" class="form-label">Currency:</label>
                    <multiselect v-model="formData.currency" placeholder="Select Currency" :custom-label="customLabel" id="currency_id" label="name_l" :class="classes"  :close-on-select="true" track-by="id" :options="currencies">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.name_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.name_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider tag="div" v-slot="{ classes }" class="d-flex align-items-center mb-3">
                    <label for="is_active" class="form-label">Is Active:</label>
                    <input id="is_active" class="ml-5 wd-25 ht-25" name="is_active" v-model="formData.is_active" placeholder="title" :class="classes" type="checkbox">
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const page = 'paymentRequisite'
const url = 'payment-requisite'
export default {
  name: 'roomBaseAdd',
  data () {
    return {
      page: page,
      url: url,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      currencies: [],
      selectData: [],
      discounts: [],
      formData: {
        title_l: {},
        remark_l: {}
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    this.getAllCurrency().then((res) => {
      this.currencies = res.data
    })
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
      })
    }
  },
  methods: {
    ...mapActions({
      getAllCurrency: 'currency/getAllCurrency',
      create: page + '/create',
      update: page + '/update',
      getData: page + '/getData'
    }),
    customLabel (data) {
      return `${data.name_l[this.$i18n.locale]}`
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          this.formData.currency_id = this.formData.currency.id
          delete this.formData.currency
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
